export default __webpack_public_path__ + "static/media/bihorel7.94659d32.jpg";